import stylesheet from './ImageGallerySmall.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTImageGallerySmall extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add('gallery');
        container.innerHTML = `<slot></slot>`;
        this.getSlotElements().forEach((slotElement, index) => {
            if ([0, 3, 4].includes(index)) {
                slotElement.setAttribute('aspect-ratio-md', '4 / 3');
            } else if ([5].includes(index)) {
                slotElement.setAttribute('aspect-ratio-md', 'auto');
            } else {
                slotElement.setAttribute('aspect-ratio-md', '16 / 9');
            }
            if ([1, 2, 4].includes(index)) {
                slotElement.setAttribute('aspect-ratio', '16 / 9');
            } else if ([3].includes(index)) {
                slotElement.setAttribute('aspect-ratio', '4 / 3');
            } else if ([0].includes(index)) {
                slotElement.setAttribute('aspect-ratio', '3 / 2');
            } else {
                slotElement.setAttribute('aspect-ratio', 'auto');
            }
        })
        return container;
    }
}

customElements.define('nxt-image-gallery-small', NXTImageGallerySmall);
